import { render, staticRenderFns } from "./fontV2.vue?vue&type=template&id=2ded0236&scoped=true"
import script from "./fontV2.vue?vue&type=script&lang=js"
export * from "./fontV2.vue?vue&type=script&lang=js"
import style0 from "./fontV2.vue?vue&type=style&index=0&id=2ded0236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ded0236",
  null
  
)

export default component.exports